import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import EventsFilterDrawer from "../../../../components/sections/front/orderReporting/EventsFilterDrawer";
import Tabs from "../../../../components/elements/Tabs";
import AddOnsList from "../../../../components/sections/front/orderReporting/AddOnsList";
import ExportsList from "../../../../components/sections/front/orderReporting/ExportsList";
import { useTranslation } from "react-i18next";

const AddOnsReporting = () => {
  const { t } = useTranslation();
  const { lang } = useSelector((state) => state?.langProvider);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [drawer, setDrawer] = useState({
    isOpen: selectedEvents?.length === 0,
    data: null,
  });

  const tabs = [
    {
      label: t("Preview"),
      content: (
        <AddOnsList selectedEvents={selectedEvents} setDrawer={setDrawer} />
      ),
    },
    {
      label: t("Exports"),
      content: <ExportsList queryKeys={["add-ons"]} type="add-ons" />,
    },
  ];

  return (
    <>
      <div className="w-full flex flex-col pb-10 bg-white rounded-md">
        <div className="space-y-4 py-8 px-5">
          <div className="space-y-1">
            <Link
              to={`/${lang}/user/reporting`}
              className="font-semibold hover:no-underline text-sm"
            >
              <i className="fa-regular fa-fw fa-chevron-left"></i>{" "}
              {t("Reporting")}
            </Link>
            <div className="font-bold text-xl xl:text-4xl tracking-tighter">
              {t("Addons")}
            </div>
          </div>
          <Tabs items={tabs} />
        </div>
      </div>
      <EventsFilterDrawer
        open={drawer?.isOpen}
        close={() => {
          setDrawer({ isOpen: false, data: null });
        }}
        selectedEvents={selectedEvents}
        setSelectedEvents={setSelectedEvents}
      />
    </>
  );
};

export default AddOnsReporting;
